import React from 'react';

import './style.scss';

const Heading = (props) => {
  const { style, text, type } = props;

  return (
    <p style={{ fontSize: type === 'heading-1' ? '20px' : '16px', ...style }}>
      {text}
    </p>
  );
};

export default Heading;
